import React, { useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Box, Button, TextField, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useResetPassword } from '../../hooks/api/auth'
import getSubmissionErrors from '../../utils/submissionErrors'

const ResetPasswordForm = ({ token }) => {
  const [submitted, setSubmitted] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    watch,
  } = useForm({ criteriaMode: 'all' })

  const { mutateAsync } = useResetPassword()

  const onSubmit = async (data) => {
    try {
      await mutateAsync({ ...data, token })
      setSubmitted(true)
    } catch (err) {
      for (const { name, message } of getSubmissionErrors(err)) {
        setError(name, { message })
      }
    }
  }

  const password = useRef({})
  password.current = watch('password', '')

  if (submitted) {
    return (
      <Box display='flex' flexDirection='column'>
        <Box mb={2}>
          <Typography variant='p'>Password has been reset.</Typography>
        </Box>
        <Button variant='contained' component={RouterLink} to='/login'>
          Back to login
        </Button>
      </Box>
    )
  }

  if (errors?.['token']) {
    return (
      <Box display='flex' flexDirection='column'>
        <Box mb={2}>
          <Typography variant='p' color='error'>
            {errors?.['token']?.message}
          </Typography>
        </Box>
        <Button variant='contained' component={RouterLink} to='/login'>
          Back to login
        </Button>
      </Box>
    )
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box display='flex' flexDirection='column' rowGap={2} justifyContent='space-between'>
        <TextField
          type='password'
          label='Password'
          inputProps={{
            ...register('password', {
              required: 'Password is required.',
              minLength: { value: 6, message: 'Password must be 6 or more characters long.' },
            }),
          }}
          error={Boolean(errors?.['password'])}
          helperText={errors?.['password']?.message}
        />

        <TextField
          type='password'
          label='Confirm Password'
          inputProps={{
            ...register('confirmPassword', {
              validate: (value) => value === password.current || 'Password does not match.',
            }),
          }}
          error={Boolean(errors?.['confirmPassword'])}
          helperText={errors?.['confirmPassword']?.message}
        />

        <Button type='submit' variant='contained' disabled={isSubmitting}>
          Submit
        </Button>
      </Box>
    </form>
  )
}

export default ResetPasswordForm
